import { render } from "./TheSkills.vue?vue&type=template&id=77036742&scoped=true&ts=true"
import script from "./TheSkills.vue?vue&type=script&lang=ts"
export * from "./TheSkills.vue?vue&type=script&lang=ts"

import "./TheSkills.vue?vue&type=style&index=0&id=77036742&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77036742"]])

export default __exports__